"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "ja": {
        "translation": {
            "page_header": {
                "example": "例",
                "icons": {
                    "academy": "アカデミー",
                    "asset_inventory": "資産インベントリ",
                    "assets_and_attributes": "資産と属性",
                    "assurance_plans": "保証計画",
                    "bulk_importer": "一括インポート",
                    "compliance_maps": "コンプライアンス マップ",
                    "community": "コミュニティ",
                    "frameworks": "フレームワーク",
                    "issue_tracker": "問題の追跡ツール",
                    "launchpad": "Launchpad",
                    "mission_control": "ミッション コントロール",
                    "projects": "プロジェクト",
                    "reports": "レポート",
                    "results": "リザルト",
                    "robots": "ロボット",
                    "scheduler": "スケジューラ",
                    "storyboard": "ストーリーボード",
                    "strategy": "ストラテジー",
                    "task_tracker": "タスクの追跡ツール",
                    "time_sheets": "タイムシート",
                    "toolkits": "ツールキット"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=ja.js.map